import { memo } from "react";

import GhostEnvironmentPossibleIntegration from "./PossibleDestination";

// -----------------------------------------------------------------------------

const GhostEnvironmentPossibleIntegrations = memo(
  function GhostEnvironmentPossibleIntegrations() {
    return (
      <>
        <GhostEnvironmentPossibleIntegration />
        <GhostEnvironmentPossibleIntegration />
        <GhostEnvironmentPossibleIntegration />
        <GhostEnvironmentPossibleIntegration />
      </>
    );
  }
);

export default GhostEnvironmentPossibleIntegrations;
